import { createFileRoute } from '@tanstack/react-router';
import { fallback, zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import { AdminPageContent } from '@/features/admin/components/AdminPageContent';
import {
  AdminPageHeader,
  BreadcrumbItemProps,
} from '@/features/admin/components/AdminPageHeader';
import { CourseProgressRoot } from '@/features/course-progress/Root';
import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { requireRole } from '@/lib/validation';

const progressSearchParams = z.object({
  courseId: fallback(z.string(), '').default(''),
  studentId: fallback(z.string(), '').default(''),
});

const breadcrumbItems: BreadcrumbItemProps[] = [
  {
    label: 'Admin',
    link: { to: '/admin' },
  },
  {
    label: 'Course Progress',
    link: { to: '/admin/course-progress' },
  },
];

export const Route = createFileRoute('/admin/course-progress')({
  component: RouteComponent,
  validateSearch: zodValidator(progressSearchParams),
  beforeLoad: requireRole([UserRoles.ADMINISTRATOR]),
  ssr: false,
});

function RouteComponent() {
  return (
    <>
      <AdminPageContent>
        <AdminPageHeader breadcrumbItems={breadcrumbItems} />
        <CourseProgressRoot />
      </AdminPageContent>
    </>
  );
}
